export const createHoverOrActiveState = (disableActiveState?: boolean) => (styles: Record<string, unknown>) =>
  disableActiveState
    ? {}
    : {
        // styles for device that has a mouse or stylus
        '@media not (any-pointer: coarse)': {
          '&:hover': styles,
        },
        // styles for device that has touchscreen or no pointing devices
        // for no pointing devices the user is using a keyboard
        '@media (any-pointer: coarse)': {
          '&:active': styles,
        },
      }
